<template lang="html">
    <div class="page" id="lessonHistory" v-if="player">
        <header class="pageHeader rounded">
            <fade-image class="darken" src="assets/headers/lessons.png" />
        </header>

        <div class="scroller2">
            <div v-if="!form.records">
                <pre-loader-item v-for="n in 5" :key="n" />
            </div>

            <div v-else>
                <header class="lessonHistoryHeader">
                    <h2>
                        {{ $date(date).format("DD MMM YYYY") }}
                        <!--<span style="font-size:0.8rem" v-if="true">Synced</span>
            <span style="font-size:0.8rem" v-else>Not synced</span>-->
                    </h2>

                    <ul class="links">
                        <li><star-lesson :lesson="lesson" /></li>
                        <li>
                            <a class="cancel" @click.prevent="goBack"><x-icon class="icon" /></a>
                        </li>
                    </ul>
                </header>

                <span class="info name mb10"
                    >{{ lesson.player.first_name }} {{ lesson.player.last_name }}</span
                >

                <empty-placeholder class="mt30" v-if="form.records.length == 0">
                    TIP: Start creating your lesson record here. To get started add a new section by
                    tapping on the button below.
                </empty-placeholder>

                <div class="buttons" v-if="!editMode">
                    <button class="button" @click.prevent="editMode = true" type="button">
                        Edit
                    </button>
                    <!--<button @click.prevent="editMode = true" class="button red half" type="button">Delete</button>-->
                </div>

                <button
                    @click.prevent="confirmRecord"
                    v-if="editMode"
                    :disabled="form.busy"
                    class="button"
                    type="submit"
                    name="button"
                >
                    {{ form.busy ? "Syncing record..." : "Sync Records" }}
                </button>

                <span class="info name mb10 white" v-if="lesson.title && !editMode">{{
                    form.title
                }}</span>

                <span class="syncing" v-if="syncing">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        style="margin: auto; display: block; shape-rendering: auto"
                        width="100px"
                        height="100px"
                        viewBox="0 0 100 100"
                        preserveAspectRatio="xMidYMid"
                    >
                        <circle
                            cx="50"
                            cy="50"
                            fill="none"
                            stroke="#61c45c"
                            stroke-width="10"
                            r="22"
                            stroke-dasharray="103.67255756846316 36.55751918948772"
                        >
                            <animateTransform
                                attributeName="transform"
                                type="rotate"
                                repeatCount="indefinite"
                                dur="1s"
                                values="0 50 50;360 50 50"
                                keyTimes="0;1"
                            ></animateTransform>
                        </circle>
                    </svg>
                    Syncing lesson record...
                    <br />
                    <template v-if="currentlySyncingIndex >= 0"
                        >{{ parseInt(currentlySyncingIndex) + 1 }} of
                        {{ recordsToSync.length }}</template
                    >
                </span>

                <form class="form3 whiteBG" :class="{ disabled: !editMode }" v-else>
                    <!--  v-if="editMode && (form.records.length > 0 || lesson.title)" -->
                    <div v-if="editMode" class="formGroup" style="margin-bottom: 10px">
                        <input
                            @input="saveTitle"
                            type="text"
                            v-model="form.title"
                            placeholder="Add title..."
                        />
                    </div>

                    <template v-for="(record, index) in form.records">
                        <div :key="index">
                            <content-text
                                @saveData="saveRecord"
                                v-if="record.type == 'text'"
                                v-model="record.content"
                                :record="record"
                                @sectionDeleted="deleteSection"
                                :index="index"
                                :editMode="editMode"
                            />

                            <content-image
                                @saveData="saveRecord"
                                v-else-if="record.type == 'singleImage'"
                                v-model="record.image"
                                :record="record"
                                @sectionDeleted="deleteSection"
                                :index="index"
                                :editMode="editMode"
                            />

                            <content-double-image
                                @saveData="saveRecord"
                                v-else-if="record.type == 'doubleImage'"
                                v-model="record.images"
                                :record="record"
                                @sectionDeleted="deleteSection"
                                :index="index"
                                :editMode="editMode"
                            />

                            <content-video
                                @saveData="saveRecord"
                                v-else-if="record.type == 'video'"
                                v-model="record.video"
                                class="video"
                                :record="record"
                                @sectionDeleted="deleteSection"
                                :index="index"
                                :editMode="editMode"
                                @reloadComponent="++record.loadAttempts"
                                :key="record.ref + '_' + record.loadAttempts"
                                @confirmrecord="confirmRecord"
                            />

                            <!--<directional-graph @saveChartData="saveRecord" v-else-if="record.type == 'chart'" v-model="record.chart" :mainIndex="index" :index="index" :editMode="editMode" :readonly="!editMode"/>-->

                            <directional-graph2
                                @saveChartData="saveRecord"
                                @sectionDeleted="deleteSection"
                                :record="record"
                                :graphId="index"
                                v-else-if="record.type == 'chart'"
                                v-model="record.chart"
                                :index="index"
                                :editMode="editMode"
                                :readonly="!editMode"
                            />

                            <putting-chart
                                v-else-if="record.type == 'putting_chart'"
                                @saveChartData2="saveRecord"
                                @sectionDeleted="deleteSection"
                                :record="record"
                                :graphId="index"
                                v-model="record.chart"
                                :index="index"
                                :editMode="editMode"
                                :readonly="!editMode"
                                :metric="record.metric"
                                @metric="record.metric = $event"
                            />

                            <template v-if="index == 1 && record.is_player_submitted">
                                <div
                                    class="recordText"
                                    style="background: #f6d5a6"
                                    v-if="lesson.player_video_lesson_note"
                                >
                                    <strong style="margin-bottom: 5px">Player notes:</strong>
                                    <p style="line-height: 22px">
                                        {{ lesson.player_video_lesson_note }}
                                    </p>
                                </div>
                            </template>
                        </div>
                        <!-- End for each -->
                    </template>

                    <div
                        class="recordText"
                        v-if="lesson.player_note || (lesson.comments && lesson.comments.length)"
                    >
                        <strong>Player comments</strong><br />
                        <img class="icon" src="@/assets/icons/profile.svg" />
                        <div class="comment">
                            {{ lesson.player_note }}
                        </div>
                        <div class="comment" v-for="comment in lesson.comments" :key="comment.id">
                            {{ comment.content }}
                        </div>
                    </div>

                    <div v-if="editMode">
                        <div class="addNewSection">
                            <!--<button class="button dark mb10 left" type="button" name="button" @click.prevent="titleOpen = true" v-if="!titleOpen">
                {{(form.title) ? 'Edit' : 'Add' }} title
                    <plus-icon class="icon"/>
              </button>

              <div class="formGroup" v-else style="margin-bottom:10px">
                    <input type="text" v-model="form.title">
                    <button style="margin-top:10px;" v-if="form.records.length == 0" @click.prevent="saveRecord" class="button" type="button" name="button">{{(form.busy) ? 'Please wait' : 'Save'}}</button>
              </div>-->

                            <button
                                class="button dark mb left"
                                @click.prevent="contextOpen = !contextOpen"
                                type="button mb30"
                                name="button"
                            >
                                Add new section
                                <plus-icon class="icon" />
                            </button>

                            <ul
                                class="contextMenu"
                                v-if="contextOpen"
                                v-on-clickaway="closeContext"
                            >
                                <li @click.prevent="addText"><span class="box">Text</span></li>
                                <li
                                    @click.prevent="
                                        subMenuOpen = true;
                                        subMenu2Open = false;
                                    "
                                >
                                    <span class="box">Image</span>
                                    <ul class="sub" v-if="subMenuOpen">
                                        <li @click.prevent="addSingleImage">
                                            <span class="box">
                                                <span class="single"></span>
                                                Single
                                            </span>
                                        </li>
                                        <li @click.prevent="addDoubleImage">
                                            <span class="box">
                                                <span class="single double"></span>
                                                <span class="single double"></span>
                                                Double
                                            </span>
                                        </li>
                                    </ul>
                                </li>
                                <li @click.prevent="addVideo"><span class="box">Video</span></li>
                                <li
                                    @click.prevent="
                                        subMenu2Open = true;
                                        subMenuOpen = false;
                                    "
                                >
                                    <span class="box">Dispersion chart</span>
                                    <ul class="sub" v-if="subMenu2Open">
                                        <li @click.prevent="addChart">
                                            <span class="box">Shot</span>
                                        </li>
                                        <li @click.prevent="addPuttingChart">
                                            <span class="box">Putting</span>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <span class="clear"></span>
                        </div>

                        <button
                            @click.prevent="confirmRecord"
                            v-if="editMode"
                            :disabled="form.busy"
                            class="button"
                            type="submit"
                            name="button"
                        >
                            {{ form.busy ? "Syncing record..." : "Sync Record" }}
                        </button>
                        <!--<button v-if="form.records.length > 0" class="button half red" type="submit" name="button" @click.prevent="cancelRecord">Cancel</button>-->

                        <!-- <button style="margin-top:10px" @click.prevent="clearLocalData" type="button" class="button red">Clear phone data</button> -->
                    </div>
                </form>
            </div>
            <!-- End else -->
        </div>
    </div>
</template>

<script>
import FadeImage from "@/components/App/fade-image";
import StarLesson from "@/components/Player/Lessons/lesson-star";
import PreLoaderItem from "@/components/App/Pre-loader-item";
import { Form } from "vform";
import { PlusIcon, XIcon } from "vue-feather-icons";
import { mixin as clickaway } from "vue-clickaway";
import ContentText from "@/components/Pro/Lessons/content/content-text";
import ContentImage from "@/components/Pro/Lessons/content/content-image";
import ContentVideo from "@/components/Pro/Lessons/content/content-video";
import ContentDoubleImage from "@/components/Pro/Lessons/content/content-double-image";
import objectToFormData from "object-to-formdata";
//import DirectionalGraph from '@/components/Pro/Lessons/content/directional-graph'
import DirectionalGraph2 from "@/components/Pro/Lessons/content/directional-graph2";
import PuttingChart from "@/components/Pro/Lessons/content/putting-chart";
import * as JsStore from "jsstore";
import * as Sentry from "@sentry/vue";

const getWorkerPath = () => {
    // return dev build when env is development
    if (process.env.NODE_ENV === "development") {
        return require("file-loader?name=scripts/[name].[hash].js!jsstore/dist/jsstore.worker.js");
    } else {
        // return prod build when env is production
        return require("file-loader?name=scripts/[name].[hash].js!jsstore/dist/jsstore.worker.min.js");
    }
};

var workerPath = getWorkerPath();

var debounce = require("debounce");

import EmptyPlaceholder from "@/components/App/empty-placeholder";
export default {
    name: "proPlayerLesson",
    mixins: [clickaway],
    components: {
        PuttingChart,
        EmptyPlaceholder,
        DirectionalGraph2,
        FadeImage,
        StarLesson,
        XIcon,
        ContentVideo,
        PreLoaderItem,
        PlusIcon,
        ContentText,
        ContentImage,
        ContentDoubleImage,
    },
    mounted() {
        if (!this.$store.state.activePlayer) {
            this.$store.dispatch("getPlayer", this.$route.params.id);
        }
        this.getLesson();
        this.initJsStore();
    },
    computed: {
        player() {
            return this.$store.state.activePlayer;
        },
        recordsToSync() {
            return this.form.records;
        },
    },
    data() {
        return {
            connection: new JsStore.Connection(new Worker(workerPath)),
            database: false,
            oWebViewInterface: window.nsWebViewInterface,
            editMode: false,
            deleteOpen: false,
            contextOpen: false,
            subMenuOpen: false,
            subMenu2Open: false,
            titleOpen: false,
            records: [],
            date: "",
            lesson: false,
            saved: false,
            gotDatab: "hello",
            form: new Form({
                title: "",
                records: false,
            }),
            originalRecords: null,
            busy: false,
            syncing: false,
            requiresSync: false,
            currentlySyncingIndex: 1,
        };
    },
    methods: {
        saveTitle: debounce(function () {
            this.requiresSync = true;
            this.saveRecord();
        }, 800),
        clearLocalData() {
            this.$confirm(
                "This will clear all the lesson record data stored locally on your phone. It wont affect any that have been synced. Do you want to continue?",
                () => {
                    this.connection.clear("LessonRecords");
                    this.$notify("Records cleared");
                    this.form.title = "";
                    this.form.records = [];
                },
            );
            //
        },
        initJsStore() {
            //this.connection.clear('LessonRecords');
            //
            this.database = this.getDbSchema();

            //this.connection.clear('LessonRecords');

            this.connection
                .select({
                    from: "LessonRecords",
                })
                .then(() => {});

            //this.connection.dropDb();

            const isDbCreated = this.connection.initDb(this.database).then(() => {
                if (isDbCreated === true) {
                    this.gotDatab = "created";
                    // here you can prefill database with some data
                } else {
                    this.gotDatab = "opened";
                }
            });
        },
        getDbSchema() {
            var lessonRecord = {
                name: "LessonRecords",
                columns: {
                    id: { enableSearch: true, notNull: true },
                    content: { enableSearch: true, notNull: true },
                },
            };
            var db = {
                name: "LessonPro",
                tables: [lessonRecord],
            };
            return db;
        },
        goBack() {
            if (!this.editMode) {
                this.$router.back();
                return;
            }
            this.$router.back();
        },
        cancelRecord() {
            this.$confirm("Are you sure you want to exit this record without saving?", () => {
                this.editMode = false;
            });
        },
        closeContext() {
            this.subMenuOpen = false;
            this.$nextTick(() => {
                this.contextOpen = false;
            });
        },
        addText() {
            this.form.records.push({
                type: "text",
                content: "",
                ref: this.generateRef(),
            });
            this.closeContext();
        },
        openImage() {
            this.subMenuOpen = true;
        },
        addSingleImage() {
            this.form.records.push({
                type: "singleImage",
                image: false,
                ref: this.generateRef(),
            });
            this.closeContext();
        },
        addDoubleImage() {
            this.form.records.push({
                type: "doubleImage",
                images: [],
                ref: this.generateRef(),
            });
            this.closeContext();
        },
        addVideo() {
            this.form.records.push({
                type: "video",
                video: false,
                ref: this.generateRef(),
                loadAttempts: 0,
            });
            this.closeContext();
        },
        addChart() {
            this.form.records.push({
                type: "chart",
                chart: "",
                ref: this.generateRef(),
            });
            this.closeContext();
        },
        addPuttingChart() {
            this.form.records.push({
                type: "putting_chart",
                chart: "",
                metric: false,
                ref: this.generateRef(),
            });
            this.closeContext();
        },
        getLesson() {
            this.busy = true;
            window.axios.get("/lesson/" + this.$route.params.lesson).then((response) => {
                this.form.records = !response.data.record ? [] : response.data.record;

                this.form.title = response.data.title;
                // if(response.data.record && Array.isArray(response.data.record)) {
                //   this.originalRecords = [];
                //   for(let record of response.data.record){
                //     this.originalRecords.push(Object.assign({}, record))
                //   }
                // } else {
                //   this.originalRecords = [];
                // }

                if (this.form.records.length == 0) {
                    this.editMode = true;
                }

                this.getSavedDBRecord();

                this.lesson = response.data;
                this.date = response.data.date;
                this.busy = false;
            });
        },
        //get form that is saved in the local db, and if it exists overwrite the form
        getSavedDBRecord() {
            this.connection
                .select({
                    from: "LessonRecords",
                    where: {
                        id: Number(this.$route.params.lesson),
                    },
                })
                .then((response) => {
                    if (response.length > 0) {
                        this.$nextTick(() => {
                            let diffCount =
                                response[0].content.records.length - this.form.records.length;
                            this.form.records = this.mergeRecordsByRef(
                                response[0].content.records,
                                this.form.records,
                            );
                            this.form.title = response[0].content.title;
                            this.requiresSync = true;
                            if (diffCount > 0) {
                                this.editMode = true;
                            }
                        });
                    }
                });
        },
        // merge array of records 'a' into 'b' and maintain unique refs. If refs exist in both then keep b
        mergeRecordsByRef(a, b) {
            for (let record of a) {
                if (
                    !b.filter(function (r) {
                        return r.ref == record.ref;
                    }).length
                ) {
                    b.push(record);
                }
            }
            return b;
        },
        // delete form from local db
        removeDBRecord() {
            this.connection.remove({
                from: "LessonRecords",
                where: {
                    id: Number(this.$route.params.lesson),
                },
            });
        },
        // save whole form to local db
        saveRecord() {
            this.busy = false;
            this.saved = true;

            this.removeDBRecord();

            this.connection.insert({
                into: "LessonRecords",
                upsert: false,
                values: [
                    {
                        id: Number(this.$route.params.lesson),
                        content: this.form.data(),
                    },
                ],
            });

            this.busy = false;

            //this.saveToRemoteDB($fromButton);
        },
        // save to server, and confirm first if no title is set
        confirmRecord() {
            if (!this.form.title) {
                this.$confirm(
                    "You haven't added a title. Are you sure you want to continue?",
                    () => {
                        this.saveToRemoteDB();
                    },
                );
            } else {
                this.saveToRemoteDB();
            }
        },
        // save to server
        async saveToRemoteDB() {
            this.syncing = true;
            let errorOccured = false;

            for (let i in this.recordsToSync) {
                this.currentlySyncingIndex = i;
                let record = Object.assign({}, this.recordsToSync[i]);

                if (record.type == "video") {
                    if (!record["video_url"]) {
                        record["video"] = this.dataURLtoFile(record.video, "aaron.mp4");
                    }
                } else if (record.type == "singleImage") {
                    if (!record.image_url) {
                        record["image"] = this.dataURLtoFile(record.image, "aaron.jpeg");
                    }
                } else if (record.type == "doubleImage") {
                    if (record.images) {
                        record.images.forEach((image, imageIndex) => {
                            if (image && image.length > 0 && image !== "false") {
                                record["images"][imageIndex] = this.dataURLtoFile(
                                    image,
                                    "aaron.jpeg",
                                );
                            }
                        });
                    }
                }

                try {
                    await this.form.submit(
                        "POST",
                        "/lesson/" + this.$route.params.lesson + "/record",
                        {
                            transformRequest: [
                                () => {
                                    return objectToFormData(
                                        { title: this.form.title, records: [record] },
                                        {
                                            indices: true,
                                            booleansAsIntegers: true,
                                        },
                                    );
                                },
                            ],
                        },
                    );
                } catch (e) {
                    Sentry.captureException(e);
                    errorOccured = true;
                    this.$notify({ clean: true });
                    this.$notify({
                        type: "error",
                        duration: 10000,
                        title: "Upload Error",
                        text: "There was an error syncing your data. Please check your connection and try again.",
                    });
                    break;
                }
            }

            // save the title
            try {
                await this.form.submit("POST", "/lesson/" + this.$route.params.lesson + "/record", {
                    transformRequest: [
                        () => {
                            return objectToFormData(
                                { title: this.form.title, records: [] },
                                {
                                    indices: true,
                                    booleansAsIntegers: true,
                                },
                            );
                        },
                    ],
                });
            } catch (e) {
                Sentry.captureException(e);
                errorOccured = true;
                this.$notify({ clean: true });
                this.$notify({
                    type: "error",
                    duration: 10000,
                    title: "Upload Error",
                    text: "There was an error syncing your data. Please check your connection and try again.",
                });
            }

            this.currentlySyncingIndex = -1;
            this.syncing = false;

            if (!errorOccured) {
                this.requiresSync = false;
                this.$notify({ clean: true });
                this.$notify("Lesson Record Synced");
                this.removeDBRecord();
            }

            this.form = new Form({
                title: this.form.title,
                records: false,
            });
            this.getLesson();

            // fetch the user to update incomplete record count
            this.$store.dispatch("getUser");
        },
        deleteSection(index, record) {
            this.$confirm("Are you sure you want to delete this section?", () => {
                this.busy = true;

                window.axios
                    .delete(
                        "/lesson/" +
                            this.$route.params.lesson +
                            "/record/" +
                            record.ref +
                            "/delete",
                    )
                    .then(() => {
                        this.form.records = this.form.records.filter((r) => r.ref != record.ref);
                        this.saveRecord();
                        this.getLesson();
                    })
                    .catch(() => {
                        this.busy = false;
                        this.$notify({ clean: true });
                        this.$notify({
                            type: "error",
                            duration: -1,
                            title: "Upload Error",
                            text: "There was an error syncing your data. Please check your connection and try again.",
                        });
                    });
            });
        },
        generateRef() {
            return Date.now() + "" + (Math.floor(Math.random() * 90000) + 10000);
        },
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(","),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }

            return new File([u8arr], filename, { type: mime });
        },
        // recordExistsLocally() {
        //   this.connection
        //     .select({
        //       from: "LessonRecords",
        //       where: {
        //         id: Number(this.$route.params.lesson),
        //       },
        //     })
        //     .then((response) => {
        //       if (response.length > 0) {
        //         return true;
        //       } else {
        //         return false;
        //       }
        //     });
        // },
    },
};
</script>

<style lang="scss">
#lessonHistory {
    .comment {
        margin-bottom: 20px;
    }
    .comment:last-child {
        margin-bottom: 0;
    }
    .clear {
        display: block;
        clear: both;
    }
    .formGroup {
        margin-bottom: 10px !important;
    }
    .buttons {
        margin-bottom: 10px;
    }
    .lessonHistoryHeader {
        position: sticky;
        top: 0px;
        background: #eef5f2;
        padding-top: 20px;
        padding-bottom: 5px;
        z-index: 34;
        margin-left: -20px;
        padding-left: 20px;
        margin-top: -20px;

        .links {
            top: 15px;
        }
        .cancel {
            transform: translateY(3px);
            display: block;
        }
    }
    .name {
        font-size: 16px;
    }
    .addNewSection {
        position: relative;
        margin-bottom: 30px;
        .contextMenu {
            z-index: 1;
            float: right;
            margin-bottom: 20px;
            width: 150px;
            li {
                margin-bottom: 5px;

                position: relative;

                .box {
                    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1) !important;
                    font-size: 14px;
                }

                .single {
                    width: 100%;
                    height: 30px;
                    background: white;
                    display: block;
                    border-radius: 4px;
                    margin: 0 auto;
                    margin-bottom: 12px;

                    &.double {
                        float: left;
                        width: calc(50% - 2px);
                        &:first-of-type {
                            margin-right: 4px;
                        }
                    }
                }
            }
            .sub {
                right: 160px;
                position: absolute;
                top: 0px;
                display: flex;
                li {
                    flex: 1;
                    .box {
                        background: $green_2;
                    }
                    &:first-of-type {
                        margin-right: 8px;
                    }
                }
            }
        }
    }
    .singleImage,
    .video {
        background: $green_2;
        width: 100%;
        min-height: 200px;
        margin-bottom: 20px;
        border-radius: $radius;
        position: relative;
        input[type="file"] {
            opacity: 0;
        }
        &.selected {
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        }
    }
    .singleImage.video {
        background: #257961;
    }
    .doubleImage {
        display: flex;
        position: relative;
        .half {
            background: $green_2;
            width: calc(50% - 10px);
            height: 200px;
            margin-bottom: 20px;
            border-radius: $radius;
            position: relative;

            &:first-of-type {
                margin-right: 20px;
            }
            input[type="file"] {
                opacity: 0;
            }
        }
        &.selected {
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        }
    }
    .plusIcon {
        background: white;
        display: block;
        border-radius: 12px;
        width: 40px;
        height: 40px;
        line-height: 51px;
        text-align: center;
        margin: 0 auto;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -20px;
        margin-top: -20px;
    }
}
.recordText {
    padding: 15px 20px;
    background: #bbf8e0;
    border-radius: $radius;
    color: $green_0;
    font-weight: 200;
    position: relative;
    margin-bottom: 20px;
    strong {
        font-weight: 700;
        margin-bottom: 0px;
        display: block;
    }
    .icon {
        position: absolute;
        right: 20px;
        width: 24px;
        top: 15px;
    }
}
.form3.disabled {
    .formGroup {
        margin-bottom: 10px;
    }
}
.syncing {
    color: #257961;
    display: block;
    margin-top: 20px;
    text-align: center;
}
</style>
